import { Permission } from '@affine/graphql';
import { useI18n } from '@affine/i18n';

import { SettingsBadge } from './settings-entity';

export const WorkspaceRoleBadge = ({ role }: { role: Permission }) => {
  const t = useI18n();
  const label =
    role === Permission.Owner
      ? t['Workspace Owner']()
      : role === Permission.Admin
        ? t['Admin']()
        : role === Permission.Editor
          ? t['com.streamlain.settings.workspace.permissions.role.editor']()
          : t['com.streamlain.settings.workspace.permissions.role.reader']();

  return <SettingsBadge variant="soft">{label}</SettingsBadge>;
};
